const pxToRem = (px) => {
	// Get the root font size (usually from the <html> element)
	const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
	// Convert px to rem
	return px / rootFontSize;
}

export default pxToRem;
